<template>
  <DefaultModal @close="$emit('close')">
    <template #header>
      <DefaultModalTitle>Avbryt ansökan på grund av</DefaultModalTitle>
    </template>

    <template #body>
      <transition name="textarea-toggle" appear>
        <div class="textarea-wrapper">
          <textarea
            :value="note"
            class="area"
            :disabled="isSaving"
            cols="30"
            rows="5"
            @input="note = $event.target.value"
          ></textarea>
        </div>
      </transition>
    </template>

    <template #footer>
      <BaseButton
        class="abort-btn"
        :is-loading="isSaving"
        :is-rounded="true"
        :icon="svgs.ICONS.ERROR_WHITE"
        @click="cancelApplication"
      >
        Markera som avbrutet
      </BaseButton>
      <BaseButton
        :is-disabled="isSaving"
        :is-rounded="true"
        :is-default="true"
        @click="$emit('close')"
        >Avbryt</BaseButton
      >
    </template>
  </DefaultModal>
</template>

<script>
import DefaultModal from '@/components/DefaultModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import DefaultModalTitle from '@/components/DefaultModalTitle.vue';
import svgs from '@/utils/icon-constants';
import { mapActions } from 'vuex';
// import churnService from '@/utils/churn360';
// import { events, features } from '@/utils/trackingEvents';

export default {
  components: {
    DefaultModal,
    BaseButton,
    DefaultModalTitle
  },

  props: {
    applicationId: {
      type: Number,
      default: null
    }
  },
  emits: ['close', 'onAborted'],

  data() {
    return {
      svgs,
      isSaving: false,
      note: ''
    };
  },

  methods: {
    ...mapActions({
      abortOvApp: 'applications/abortOvApp'
    }),
    async cancelApplication() {
      this.isSaving = true;
      await this.abortOvApp({ id: this.applicationId, note: this.note });
      // churnService.track(
      //   events.CHANGE_SWAP_STATUS,
      //   features.CHANGE_SWAP_STATUS.REMOVE
      // );
      this.isSaving = false;
      this.$emit('onAborted');
    }
  }
};
</script>

<style scoped>
.disclaimer {
  padding: 0 35px;
  left: 0;
  right: 0;
  position: absolute;
}

.abort-btn {
  background-color: rgb(var(--status-aborted));
}
</style>
